module.exports = __webpack_public_path__ + "img/logo-lg.94a20663.png";